import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WakeLockService {
  private wakeLock: any = null;

  constructor() {
    // Optional: Reacquire wake lock when visibility changes
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible' && this.wakeLock === null) {
        this.requestWakeLock();
      }
    });
  }
  
  async requestWakeLock(): Promise<void> {
    try {
      if ('wakeLock' in navigator) {
        this.wakeLock = await (navigator as any).wakeLock.request('screen');
        // console.log('[WakeLock] Acquired');

        this.wakeLock.addEventListener('release', () => {
          // console.log('[WakeLock] Released by system');
          this.wakeLock = null;
        });
      } else {
        console.warn('[WakeLock] Not supported by browser');
      }
    } catch (err) {
      console.error('[WakeLock] Failed to acquire:', err);
    }
  }

  async releaseWakeLock(): Promise<void> {
    try {
      if (this.wakeLock) {
        await this.wakeLock.release();
        this.wakeLock = null;
        // console.log('[WakeLock] Released manually');
      }
    } catch (err) {
      console.error('[WakeLock] Failed to release:', err);
    }
  }
}
